import React from "react";
import { GraduationCap } from "lucide-react";

export default function Logo({ size = "md", showText = true }) {
  const sizes = {
    sm: { icon: 20, text: "text-lg" },
    md: { icon: 26, text: "text-2xl" },
    lg: { icon: 34, text: "text-3xl" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div className="flex items-center gap-2">
      <div className="w-9 h-9 rounded-xl bg-tiffany-500 flex items-center justify-center shadow-sm">
        <GraduationCap className="text-white" size={s.icon} />
      </div>
      {showText && (
        <span className={`font-display font-extrabold tracking-tight ${s.text} text-tiffany-600 dark:text-tiffany-400`}>
          estudei
        </span>
      )}
    </div>
  );
}
